import template from './questionMessageModal.html';
import controller from './questionMessageModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    riskList: '<',
  },
};
